import React from 'react';
import AuthHeader from './AuthHeader';
import Footer from './Footer';

const Authshell = ({children, showHeader}) => {
  return (
    <>
      {showHeader && <AuthHeader/>}
      <div className={`auth-wrap px-5 md:px-20 py-10 md:py-24 ${showHeader && 'header'}`}>
        {children}
      </div>
      <Footer />
    </>
  );
}

export default Authshell;
